<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品添加
    -->
  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px" v-if="!loading">
      <!--基础信息-->
      <Basic></Basic>

      <!--规格设置-->
      <Spec></Spec>

      <!--商品详情-->
      <Content></Content>

      <!--商品活动-->
      <Activity></Activity>

      <!--高级设置-->
      <Buyset></Buyset>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :disabled="save_loading">发布</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Basic from './part/Basic.vue';
import Spec from './part/Spec.vue';
import Content from './part/Content.vue';
import Buyset from './part/Buyset.vue';
import Activity from './part/Activity.vue';
import { formatModel } from '@/utils/base.js';
export default {
  components: {
    /*基础信息*/
    Basic,
    /*规格信息*/
    Spec,
    /*商品详情*/
    Content,
    /*高级设置*/
    Buyset,
    /*活动设置*/
    Activity,
  },
  data() {
    return {
      /*商品ID*/
      product_id: 0,
      /*判断是编辑*/
      scene: 'edit',
      /*是否正在加载*/
      loading: true,
      /*是否正在提交保存*/
      save_loading: false,
      /*form表单数据*/
      form: {
        model: {},
        /*标签*/
        label: [],
        /*商品分类*/
        catgory: [],
        /*运费模板*/
        delivery: [],
        store_list: [],
        /*会员等级*/
        gradeList: [],
        /*会员等级，用于代理级差*/
        gradeRangeList: [],
        supplierList: [],
        /*规格数据*/
        specData: null,
        /*是否锁住*/
        isSpecLocked: false,
        /*是否锁住活动类型*/
        isTypeLocked: false,
        /*分销基础设置*/
        basicSetting: {},
      },
      /*模型数据*/
      model: {
        /*商品名称*/
        product_name: '',
        /*商品编码*/
        product_no: '',
        /*商品分类*/
        category_id: null,
        /*商品图片*/
        image: [],
        /*商品卖点*/
        selling_point: '',
        /*规格类别,默认10单规格，20多规格*/
        spec_type: 10,
        /*库存计算方式,默认20付款减库存，10下单减库存*/
        deduct_stock_type: 20,
        /*检查用户等级*/
        is_alone_grade: 0,
        /*活动类型 0 视频 1 活动 2普通*/
        virtual_type:0,
        /*是否关联课程 0 否 1 是*/
        is_course:1,
        /*活动数据*/
        active:{
          active_time:'',
          name:'',
          address:'',
          mobile:'',
          dec:'',
          number:1,
          coordinate:'',
        },
        // 余额赠送规则
        balance_setting:{
          open:0,
          balance_type:10,
          balance_amount:0,
        },
        // 积分赠送规则
        points_setting:{
          open:0,
          rule_type:0,
          points_type:10,
          points_amount:0,
        },
        /*课程*/
        course:'',
        /*单规格*/
        sku: {
          /*产品价格*/
          product_price: 0,
          // 产品积分价
          points_price:0,
          /*产品划线价*/
          line_price: 0,
          /*库存数量*/
          stock_num: 0,
          /*商品重量*/
          product_weight: 0
        },
        /*多规格类别*/
        spec_many: {
          /*多规格类别*/
          spec_attr: [],
          /*多规格表格数据*/
          spec_list: []
        },
        /*购买权限详情*/
        buy_auth:[],
        /*查看权限详情*/
        check_auth:[],
        /*免费观看课程权限*/
        watch_auth:[],
        /*商品详情内容*/
        content: '',
        /*运费模板ID*/
        delivery_id: '',
        store_id:'',
        /*商品状态*/
        product_status: 10,
        /*初始销量*/
        sales_initial: 0,
        view_times_initial: 0,
        /*商品排序，默认100*/
        product_sort: 100,
        /*是否开启积分赠送,默认1为开启，0为关闭*/
        is_points_gift: 1,
        /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
        is_points_discount: 1,
        /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
        is_enable_grade: 1,
        /*等级金额类型,默认10为百分比，20为固定金额*/
        alone_grade_type: 10,
        /*是否开启单独分销,默认0为关闭，1为开启*/
        is_ind_agent: 0,
        /*分销佣金类型,默认10为百分比，20为固定金额*/
        agent_money_type: 10,
        /*积分抵扣类型,默认10为百分比，20为固定金额*/
        alone_credit_type:10,
        /*分销类型 0 统一 1 按等级*/
        commission_type:0,
        commission_same_grade:0,//直推平级奖励
        /*一级佣金*/
        first_money: 0,
        /*二级佣金*/
        second_money: 0,
        /*三级佣金*/
        third_money: 0,
        /*一级佣金复购*/
        first_money_member: 0,
        /*二级佣金复购*/
        second_money_member: 0,
        /*三级佣金复购*/
        third_money_member: 0,
        /*一级积分*/
        first_point: 0,
        /*二级积分*/
        second_point: 0,
        /*三级积分*/
        third_point: 0,
        /*会员折扣极差设置,默认0为关闭，1为开启*/
        is_enable_grade_discount:0,
        /*代理极差设置,默认0为关闭，1为开启*/
        is_alone_enable_grade_equity:0,
        // 返佣类型 10 百分比，20 固定金额
        alone_enable_grade_type:10,
        /*商品关联云仓设置,默认1为允许，0为不允许*/
        is_use_warehouse_product:0,
        /*云仓商品列表*/
        warehouse_product_list:[],
        /*是否虚拟商品*/
        is_virtual: 0,
        /*升级的等级*/
        up_grade_id: '',
        // 三方卡券id
        gcard_id: '',
        supplier_id: '',
        /*限购数量*/
        buy_limit_num: 0,
        open_min_buy: 0,
        /*积分抵扣*/
        points_discount: 0,
        buy_total_num: 0, //累计限购
        label_id: [],  //标签集合
        is_recommend: false,  //推荐
        is_hot: false, // 热卖
        is_new: false, //新品
        poster: '',//视频封面
        video: '',//视频
        skucate:[],// sku 分类
        platform_commission: 0,
        is_commission_pay: 0,   //佣金支付
        is_cart: 1,   //允许加入购物车
         // 2+1链动参数
        boss_agent:{
          open:0,
          agent_money:0,//代理直推
          boss_money:0,//老板直推
          boss_peer:0,//老板直推平级奖励
          agent_level_money:0,//代理层级固定返利，直推多少个代理可享受对应几代的返利
        },
        earning_setting:{
            type:0,
            rate:0,//代理直推
            month:12,//托管月份
            limit_days:10,//收益产生开始时间n天后
          },
         //区域奖励参数
        area_agent:{
          open:0,
          agent_area_type:10,/*区域奖励类型,默认10为百分比，20为固定金额*/
          province_rate:0,//省级区域奖励
          city_rate:0,//市级区域奖励
          region_rate:0,//区级区域奖励
        },
        is_multiple: 0,
      }
    };
  },
  provide: function() {
    return {
      form: this.form
    };
  },
  created() {
    /*获取列表*/
    this.product_id = this.$route.query.product_id;
    this.scene = this.$route.query.scene;
    this.getData();
  },
  methods: {
    /**
     * 获取基础数据
     */
    getData: function() {
      let self = this;
      PorductApi.getEditData(
        {
          product_id: self.product_id,
          scene: self.scene
        },
        true
      )
        .then(res => {
          self.loading = false;
          /*单独产品分销*/
          if(res.data.model.alone_money_equity!=null&&typeof res.data.model.alone_money_equity !='undefined' &&res.data.model.alone_money_equity!=''){
            let moneys=res.data.model.alone_money_equity;
            res.data.gradeList.forEach(item=>{
              self.$set(item, 'first_money',moneys['first_money'][item.grade_id]?moneys['first_money'][item.grade_id]:0)
              self.$set(item, 'second_money',moneys['second_money'][item.grade_id]?moneys['second_money'][item.grade_id]:0)
              self.$set(item, 'third_money',moneys['third_money'][item.grade_id]?moneys['third_money'][item.grade_id]:0)
              self.$set(item, 'first_money_member',moneys['first_money_member']!=undefined&&moneys['first_money_member'][item.grade_id]?moneys['first_money_member'][item.grade_id]:0)
              self.$set(item, 'second_money_member',moneys['second_money_member']!=undefined&&moneys['second_money_member'][item.grade_id]?moneys['second_money_member'][item.grade_id]:0)
              self.$set(item, 'third_money_member',moneys['third_money_member']!=undefined&&moneys['third_money_member'][item.grade_id]?moneys['third_money_member'][item.grade_id]:0)
              self.$set(item, 'first_point',moneys['first_point']!=undefined&&moneys['first_point'][item.grade_id]?moneys['first_point'][item.grade_id]:0)
              self.$set(item, 'second_point',moneys['second_point']!=undefined&&moneys['second_point'][item.grade_id]?moneys['second_point'][item.grade_id]:0)
              self.$set(item, 'third_point',moneys['third_point']!=undefined&&moneys['third_point'][item.grade_id]?moneys['third_point'][item.grade_id]:0)
            });
          }else{
            res.data.gradeList.forEach(item=>{
              self.$set(item, 'first_money', 0)
              self.$set(item, 'second_money', 0)
              self.$set(item, 'third_money',0)
              self.$set(item, 'first_money_member', 0)
              self.$set(item, 'second_money_member', 0)
              self.$set(item, 'third_money_member',0)
              self.$set(item, 'first_point', 0)
              self.$set(item, 'second_point', 0)
              self.$set(item, 'third_point',0)
            });
          }

          if(res.data.model.buy_total_set!=null&&typeof res.data.model.buy_total_set !='undefined'){
            let buy_total_set=res.data.model.buy_total_set;
            res.data.gradeList.forEach(item=>{
              item.buy_total_set=buy_total_set[item.grade_id];
            });
          }

          if(res.data.model.pick_total_set!=null&&typeof res.data.model.pick_total_set !='undefined'){
            let buy_total_set=res.data.model.pick_total_set;
            res.data.gradeList.forEach(item=>{
              item.pick_total_set=buy_total_set[item.grade_id];
            });
          }

          /*代理极差折扣*/
          if(res.data.model.alone_enable_grade_equity!=null&&typeof res.data.model.alone_enable_grade_equity !='undefined'){
            let equallys=res.data.model.alone_enable_grade_equity;
            res.data.gradeRangeList.forEach(item=>{
              if(equallys[item.grade_id]){
                item.grade_award=equallys[item.grade_id].grade_award?equallys[item.grade_id].grade_award:0;
                item.same_award=equallys[item.grade_id].same_award?equallys[item.grade_id].same_award:0;
              }else{
                item.grade_award=0;
                item.same_award=0;
              }

            });
          }
          /*单独产品折扣*/
          if(res.data.model.alone_grade_equity!=null&&typeof res.data.model.alone_grade_equity !='undefined'){
            let equitys=res.data.model.alone_grade_equity;
            res.data.gradeList.forEach(item=>{
              item.product_equity=equitys[item.grade_id];
            });
          }
          /*产品奖金*/
          if(res.data.model.alone_bonus_equity!=null&&typeof res.data.model.alone_bonus_equity !='undefined'){
            let equitys=res.data.model.alone_bonus_equity;
            res.data.gradeList.forEach(item=>{
              item.product_bonus=equitys[item.grade_id];
            });
          }
          Object.assign(self.form, res.data);
          if(!res.data.model.buy_auth){
            self.$set(self.model,'buy_auth',[]);
          }else{
            self.$set(self.model,'buy_auth',res.data.model.buy_auth);
          }
          if(!res.data.model.check_auth){
            self.$set(self.model,'check_auth',[]);
          }else{
            self.$set(self.model,'check_auth',res.data.model.check_auth);
          }
          if(!res.data.model.watch_auth){
            self.$set(self.model,'watch_auth',[]);
          }else{
            self.$set(self.model,'watch_auth',res.data.model.watch_auth);
          }
          let label = [];
          res.data.model.labels.forEach(item=>{
              label.push(item.id);
            });
          self.form.model.label_id = label;

          self.form.model.is_hot = self.form.model.is_hot == 1 ? true: false;
          self.form.model.is_recommend = self.form.model.is_recommend == 1 ? true: false;
          self.form.model.is_new = self.form.model.is_new == 1 ? true: false;

          if (res.data.specData) {
            self.$set(self.form.model, 'spec_many', res.data.specData);
          } else {
            self.$set(self.form.model, 'spec_many', {
              spec_attr: [],
              spec_list: []
            });
            self.form.model.sku = res.data.model.sku[0];
          }
          self.form.model.product_status = res.data.model.product_status.value;

        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*转JSON字符串*/
    convertJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.product_equity;
      });
      return JSON.stringify(obj);
    },
    /*转JSON字符串*/
    convertBonusJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.product_bonus ? item.product_bonus: 0;
      });
      return JSON.stringify(obj);
    },
    /*转JSON字符串*/
    convertMoneyJson(list){
      let obj={};
      let obj1={};
      let obj2={};
      let obj3={};
      let obj4={};
      let obj5={};
      let obj11={};
      let obj21={};
      let obj31={};
      let arr ={};
      list.forEach(item=>{
        obj[item.grade_id]=item.first_money;
        obj1[item.grade_id]=item.second_money;
        obj2[item.grade_id]=item.third_money;
        obj11[item.grade_id]=item.first_money_member;
        obj21[item.grade_id]=item.second_money_member;
        obj31[item.grade_id]=item.third_money_member;
        obj3[item.grade_id]=item.first_point;
        obj4[item.grade_id]=item.second_point;
        obj5[item.grade_id]=item.third_point;
      });
      arr['first_money'] = obj;
      arr['second_money'] = obj1;
      arr['third_money'] = obj2;
      arr['first_money_member'] = obj11;
      arr['second_money_member'] = obj21;
      arr['third_money_member'] = obj31;
      arr['first_point'] = obj3;
      arr['second_point'] = obj4;
      arr['third_point'] = obj5;
      return JSON.stringify(arr);
    },
    /*转JSON字符串*/
    convertEnableJson(list){
      let obj={};
      list.forEach(item=>{
        if(item.grade_id){
          obj[item.grade_id] = {'grade_award':item.grade_award ? item.grade_award: 0,'same_award':item.same_award ? item.same_award: 0};
        }
      });
      console.log(obj);
      return JSON.stringify(obj);
    },
    convertBuyJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.buy_total_set ? item.buy_total_set: 0;
      });
      return JSON.stringify(obj);
    },
    /*转JSON字符串*/
    convertPickJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.pick_total_set ? item.pick_total_set: 0;
      });
      return JSON.stringify(obj);
    },
    /*提交*/
    onSubmit: function() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          let params = formatModel(self.model, self.form.model);
          params.is_hot = params.is_hot ? 1: 0;
          params.is_recommend = params.is_recommend ? 1: 0;
          params.is_new = params.is_new ? 1: 0;
          params.scene = self.scene;
          params.image = self.ImgKeepId(params.image);
          params.product_id = self.product_id;
          params.active =JSON.stringify(params.active);
          params.alone_grade_equity=self.convertJson(self.form.gradeList);
          params.alone_bonus_equity=self.convertBonusJson(self.form.gradeList);
          params.alone_money_equity=self.convertMoneyJson(self.form.gradeList);
          params.alone_enable_grade_equity=self.convertEnableJson(self.form.gradeRangeList);
          params.buy_total_set=self.convertBuyJson(self.form.gradeList);
          params.pick_total_set=self.convertPickJson(self.form.gradeList);
          self.save_loading = true;
          PorductApi.editProduct({
             product_id: self.product_id,
             scene: self.scene,
             params: JSON.stringify(params)
          }, true)
            .then(data => {
              self.save_loading = false;
              self.$message({
                message: '保存成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.save_loading = false;
            });
        }
      });
    },

    /*图片数值只保留id*/
    ImgKeepId(list) {
      let arr = [];
      for (let i = 0, length = list.length; i < length; i++) {
        let obj = {
          image_id: list[i].image_id,
          file_id: list[i].file_id
        };
        arr.push(obj);
      }
      return arr;
    },

    /*保存为草稿*/
    Draft() {
      let self = this;
      self.form.model.product_status = 30;
      self.onSubmit();
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/edit.vue